export default "__VITE_PUBLIC_ASSET__30e2806f__"